<template>
	<main>
		<eia-form-group v-for="(o,i) of options"
			:key="o.value"
			:id="o.value">
			<template slot="label">{{ o.label }}</template>
			<eia-checkbox
				:id="o.value"
				type="radio"
				:name="'question'+question.id"
				:value="selected[i]"
				@input="update">
			</eia-checkbox>
		</eia-form-group>
	</main>
</template>

<script>

export default {
	name: 'eia-radio-question',

	model: {
		prop: 'valueProp',
		event: 'input',
	},

	props: {
		question: {
			type: Object,
			default: null,
		},
		valueProp: Object,
	},

	beforeMount(){
		this.init();
	},

	data() {
		return {
			value: null,
		};
	},

	computed: {

		options(){
			return this.question.answers;
		},

		selected(){
			const selected = [];

			this.options.forEach( ( option, i ) => {
				selected[ i ] = option.value === this.value;
			} );

			return selected;
		},

	},

	watch: {
		question(){
			this.init();
		},
	},

	methods: {
		init(){
			this.emitCurrentStage();
			this.value = this.valueProp?.value;
		},
		emit(){
			for( const a of this.question.answers ){
				if( a.value === this.value ){
					this.$emit( 'input', a );
					break;
				}
			}
		},
		emitCurrentStage(){
			this.$emit( 'currentStage', {
				title: this.question.title,
				header: this.question.question,
			} );
		},
		update( bool, inputId ) {

			if( bool ) {
				this.value = inputId;
				this.emit();
			}

		},
	},
};
</script>

<style lang="scss" scoped>
main {
	margin: 32px 0;
}
</style>
